<button
  mat-icon-button
  color="primary"
  [matMenuTriggerFor]="menu"
  (click)="$event.stopPropagation()"
  aria-label="more actions"
>
  <mat-icon>more_vert</mat-icon>
</button>
<mat-menu #menu="matMenu">
  <ng-container *ngFor="let action of events.elements">
    <mat-divider *ngIf="action.divider"></mat-divider>
    <button
      *ngIf="action.confirmationRequired && action.clicked"
      mat-menu-item
      optConfirmation
      [ngClass]="{ 'menu-item-color-warn': action.color === 'warn' }"
      title="{{ action.confirmationRequired.title }}"
      body="{{ action.confirmationRequired.body }}"
      (confirmOk)="onClick(action.clicked)"
      [disabled]="isDisabled(action.disabled)"
    >
      <mat-icon
        *ngIf="action.icon"
        [ngClass]="{ 'menu-icon-color-warn': action.color === 'warn' }"
        >{{ action.icon }}</mat-icon
      >
      {{ action.label }}
    </button>
    <button
      *ngIf="!action.confirmationRequired && action.clicked"
      mat-menu-item
      (click)="onClick(action.clicked)"
      [disabled]="isDisabled(action.disabled)"
      [ngClass]="{ 'menu-item-color-warn': action.color === 'warn' }"
    >
      <mat-icon
        *ngIf="action.icon"
        [ngClass]="{ 'menu-icon-color-warn': action.color === 'warn' }"
        >{{ action.icon }}</mat-icon
      >
      {{ action.label }}
    </button>
  </ng-container>
</mat-menu>
